module.exports = __webpack_public_path__ + "img/logo-phsargames-text.65824fe1.png";